import instance from '../utils/axios';

class SaleChanceService {

    async getList(pageIndex, keyword) {
        return await instance.post('/crm/salesChance/getData', {
            pageSize: 10,
            pageIndex: pageIndex,
            expressions: '[{"field": "数量", "expression": "count(1)"}]',
            fuzzySearch: keyword,
            sortField: 'createTime',
            sort: 'desc',
			dictionaryNames: 'customerId.可看客户,stage.dict_sale_chance_stage,custom_dropdown_5.dict_crm_sale_chance_商机等级,advisorId.base_staff,status.crm_chance_status,clueProviderId.base_staff'
        });
    }
	async getChanceById(chanceId) {
	    return await instance.get('/crm/salesChance/getChanceById?t=1584847362927&uuid=' + chanceId);
	}
	async getTab(uuid,host) {
	    return await instance.get('/crm/dynamicTab/getSelectedList?host='+host+'&hostPrimaryKey='+uuid);
	}
		async getFormParameter(dynamicTabId,createFrom,uuid,createFormTab) {
		    return await instance.get('/crm/dynamicTab/getFormParameter?dynamicTabId='+dynamicTabId+'&createFrom='+createFrom+'&hostMajorKey='+uuid+'&createFormTab='+createFormTab);
		}
	 async getFormDataList(pageIndex,id,keyword,formTableName,hostId,dictionaryNames) {
	    return await instance.post('/crm/dynamicTab/getFormDataList?formTableName='+formTableName, {
	        pageSize: 10,
	        pageIndex: pageIndex,
	        dictionaryNames: dictionaryNames,
	        expressions: '[{"field": "数量", "expression": "count(1)"}]',
	        sortField: 'createTime',
			fuzzySearch: keyword,
			[hostId]:id,
	        sortField: 'createTime',
	        sort: 'desc'
	    });
	}
	async getTransformProject(chanceCode) {
	    return await instance.get('/crm/salesChance/getTransformProject?chanceCode='+chanceCode);
	}

}

export default new SaleChanceService();